var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.016,
    height: 17.929,
    viewBox: "0 0 18.016 17.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box",
    transform: "translate(0 -0.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3933",
    "data-name": "Path 3933",
    d: "M9.218,1.339a.563.563,0,0,0-.419,0L2.079,4.027,9.008,6.8l6.929-2.771Zm7.672,3.52L9.571,7.787v8.92L16.89,13.78V4.86ZM8.445,16.708V7.786L1.126,4.859v8.921ZM8.381.293a1.689,1.689,0,0,1,1.255,0L17.662,3.5a.563.563,0,0,1,.353.522v9.754a1.126,1.126,0,0,1-.708,1.045l-8.09,3.236a.563.563,0,0,1-.419,0L.709,14.826A1.126,1.126,0,0,1,0,13.781V4.027A.563.563,0,0,1,.354,3.5Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.243c991ab1f525c994d1a4acf4513ef8.svg";
export { ForwardRef as ReactComponent };